app.directive('filterSearchSidebar', function (debounce, $rootScope, $http, $q, $compile, $document, $log) {
    return {
        restrict: 'A',
        controller: function ($scope) {
            
            var durationRangeLable = ["<10", "15", "30", "45", "60+"];
            var caloriesRangeLable = ["<50", "150", "250", "350", "500+"];

            var defaultMinDuration = 15;
            var defaultMaxDuration = 45;

            var defaultMinCalories = 50;
            var defaultMaxCalories = 450;

            jQuery(".duration-slider-range").slider({
                range: true,
                min: 0,
                max: 60,
                step: 15,
                values: [ defaultMinDuration, defaultMaxDuration ],
                slide: function( event, ui ) {
                    // console.log('From:' + ui.values[ 0 ] + 'To: ' + ui.values[ 1 ]);
                    $("#programs_filter_sidebar_minDuration").val(ui.values[0]);
                    $("#programs_filter_sidebar_maxDuration").val(ui.values[1]);
                }
            })
            .slider("pips", {
                rest: "label",
                labels: durationRangeLable
            });

            jQuery(".calories-slider-range").slider({
                range: true,
                min: 50,
                max: 450,
                step: 100,
                values: [ defaultMinCalories, defaultMaxCalories ],
                slide: function( event, ui ) {
                    // console.log('From:' + ui.values[ 0 ] + 'To: ' + ui.values[ 1 ]);
                    $("#programs_filter_sidebar_minCalories").val(ui.values[0]);
                    $("#programs_filter_sidebar_maxCalories").val(ui.values[1]);
                }
            })
            .slider("pips", {
                rest: "label",
                labels: caloriesRangeLable
            });

            $scope.resetForm = function() {
                // Set default values
                $("#programs_filter_sidebar_minDuration").val(defaultMinDuration);
                $("#programs_filter_sidebar_maxDuration").val(defaultMaxDuration);
    
                $("#programs_filter_sidebar_minCalories").val(defaultMinCalories);
                $("#programs_filter_sidebar_maxCalories").val(defaultMaxCalories);
                jQuery(".duration-slider-range").slider({values: [ defaultMinDuration, defaultMaxDuration ]});
                jQuery(".calories-slider-range").slider({values: [ defaultMinCalories, defaultMaxCalories ]});
            };

            if (isMobile.phone) {
                $scope.hideSidebarFlag = true;
            } else {
                $scope.hideSidebarFlag = false;
            }

            jQuery('.equipment-section').css({'max-height':'80px', 'overflow-y':'scroll'});
            jQuery('.equipment-up-icon').hide();

            $scope.showEquipment = function() {
                jQuery('.equipment-section').css({'max-height':'500px'});
                jQuery('.equipment-down-icon').hide();
                jQuery('.equipment-up-icon').show();
            };

            $scope.hideEquipment = function() {
                jQuery('.equipment-section').css({'max-height':'80px', 'overflow-y':'scroll'});
                jQuery('.equipment-down-icon').show();
                jQuery('.equipment-up-icon').hide();
            };
        },
        link: function ($scope, $element) {
            var $filterForm = $element.find('form');
            var $equipmentList = $element.find('.equipment-section');
            
            var methods = {
                applyNewFilters: function() {
                    var originalFormDetails = $filterForm.serialize();
                    if (originalFormDetails) {
                        var formQueryStr = $filterForm.serializeArray();
                        var postData = methods.queryStringToJSON(originalFormDetails);
                        var dataArray = JSON.parse(postData);

                        var finalPostData = {};

                        if (dataArray["programs_filter_sidebar[equipments][]"]) {
                            finalPostData.equipments = dataArray["programs_filter_sidebar[equipments][]"];
                        }

                        if (dataArray["programs_filter_sidebar[gender][]"]) {
                            finalPostData.gender = dataArray["programs_filter_sidebar[gender][]"];
                        }

                        if (dataArray["programs_filter_sidebar[level][]"]) {
                            finalPostData.level = dataArray["programs_filter_sidebar[level][]"];
                        }

                        if (dataArray["programs_filter_sidebar[noEquipmentNeeded]"]) {
                            finalPostData.noEquipmentNeeded = dataArray["programs_filter_sidebar[noEquipmentNeeded]"];
                        }

                        if (dataArray["programs_filter_sidebar[minDuration]"]) {
                            var minDurSelected = parseInt(dataArray["programs_filter_sidebar[minDuration]"]);
                            // not check if <10
                            if (minDurSelected > 0) {
                                finalPostData.minDuration = minDurSelected;
                            }
                        }

                        if (dataArray["programs_filter_sidebar[maxDuration]"]) {
                            var maxDurSelected = parseInt(dataArray["programs_filter_sidebar[maxDuration]"]);
                            // not check for 60+
                            if (maxDurSelected < 60) {
                                finalPostData.maxDuration = maxDurSelected;
                            }
                        }

                        if (dataArray["programs_filter_sidebar[minCalories]"]) {
                            var minCalSelected = parseInt(dataArray["programs_filter_sidebar[minCalories]"]);
                            // Not check for min if <50
                            if (minCalSelected > 50) {
                                finalPostData.minCalories = minCalSelected;
                            }
                        }

                        if (dataArray["programs_filter_sidebar[maxCalories]"]) {
                            var maxCalSelected = parseInt(dataArray["programs_filter_sidebar[maxCalories]"]);
                            // Check if 500+
                            if (maxCalSelected < 450) {
                                finalPostData.maxCalories = maxCalSelected;
                            }
                        }

                        var dataSend = {
                            'queryString': formQueryStr,
                            'postData': JSON.stringify(finalPostData)
                        };                     
                        console.log(dataSend);
                        // data send to filter-search-page
                        $rootScope.$broadcast('sidebarSearchData', dataSend);
                    } else { 
                        $rootScope.$broadcast('sidebarSearchData', {});
                    }
                },
                queryStringToJSON: function(qs) {
                    qs = decodeURIComponent(qs);
                    qs = qs || location.search.slice(1);
                    var pairs = qs.split('&');
                    var result = {};
                    pairs.forEach(function(p) {
                        var pair = p.split('=');
                        var key = pair[0];
                        var value = decodeURIComponent(pair[1] || '');
                        if (key !== "") {
                            if( result[key] ) {
                                if( Object.prototype.toString.call( result[key] ) === '[object Array]' ) {
                                    result[key].push( value );
                                } else {
                                    result[key] = [ result[key], value ];
                                }
                            } else {
                                result[key] = value;
                            }
                        }
                    });

                    return JSON.stringify(result);
                }
            };

            // $filterForm.find('select, input[type=checkbox]').on('change', debounce(500, false, function($event) {
            //     $scope.$apply(function() {
            //         methods.applyNewFilters();
            //     });
            // }));

            $filterForm.on('submit',function($event) {
                $event.preventDefault();

                $scope.$apply(function() {
                    methods.applyNewFilters();
                    if (isMobile.phone) {
                        $scope.hideSidebarFlag = true;
                        jQuery('html, body').animate({ scrollTop: 0 });
                    }
                });
            });

            $scope.$on('hideSidebar', function (event, data) {
                $scope.hideSidebarFlag = !$scope.hideSidebarFlag;
            });
        }
    };
});
